export default __webpack_public_path__ + "assets/holiday-cards/Reusable-Gift-Wrapping-Video-Cover.jpg";